// extracted by mini-css-extract-plugin
module.exports = {"baseLayout":"app_baseLayout__2T-ML","content":"app_content__3niDq","messageIcon":"app_messageIcon__hmE9X"};